import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ColumnChangeBO } from '../list/list.model';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { DynamicFormTemplateBo } from './dynamicformtemplate.modal';
@Injectable({
    providedIn: 'root'
})

export class DynamicFormTemplateService extends Subject<DataStateChangeEventArgs> {
    constructor(private http: HttpClient, public errorService: ErrorService,
    ) {
        super()
    }
    
    getDynamicFormTemplateConfiguration(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
        let url = "api/DynamicForm/getDynamicFormTemplateConfiguration?"
        return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    uploadDynamicFormTemplate(note: any): Observable<any> {
        let url = "api/DynamicForm/UploadDynamicTemplate";
        return this.http.post<any>(url, note, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    } 

    Savewidth(note: any): Observable<any> {
        let url = "api/ColumnChange/Savewidth?";
        return this.http.post<any>(url, note, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    getDynamicFormTemplateDownloadUrl(params): Observable<any> {
        let url = "api/DynamicForm/DownloadDynamicFormTemplate?"
        return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

    getDynamicFormDataDictionary(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
        let url = "api/DynamicForm/getDynamicFormDataDictionary?"
        return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
      generateDynamicTemplate(params): Observable<any> {
        let url = "api/DynamicForm/generateDynamicTemplate?";
        return this.http.get(url + params, { observe: 'response', responseType: 'blob' as 'arraybuffer' },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
      configureDynamicFormTemplate(params):Observable<any> {
        let url = "api/DynamicForm/configureDynamicFormTemplate";
        return this.http.post(url,params, { observe: 'response',responseType: "text"},).pipe(
          map(data=>data.body),
          catchError(this.errorService.handleError)
      
        )
      }
      DeleteFunctionForDeleteHttp(deleteList): Observable<any> {
        let url = "api/DynamicForm/DeleteDynamicFormTemplate?";
        return this.http.delete(url + deleteList, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
   
    public outputValues(CsState: DynamicFormTemplateBo): void {
        this.getConsultationList(CsState).subscribe(x => super.next(x));
    }
    getConsultationList(CsState?: DynamicFormTemplateBo): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/DynamicForm/getDynamicFormTemplates", CsState)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count'],
                    }
            ))
    }
}
